var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bill-flow-view"},[_c('BillFlow')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }